import React from 'react';

export default function BookCredits({ credit }) {
  const translator = credit.translator || credit.translatorNote || '譯者待查';
  const narrator = credit.narrator || credit.narratorNote || '朗讀者待查';
  return credit.translator && credit.translator === credit.narrator
    ? <>譯・朗讀｜{translator}</>
    : <>翻譯｜{translator}<br />朗讀｜{narrator}</>;
}
